<template>
  <div>
    <div :class="stepClass">
      <custom-input
        stop-clearfix
        :label-as-a-container="false"
        :warning-text="warning"
        label="Gallery images"
      >
        <file-uploader
          v-model="value.files"
          :submitted="false"
          :identifier="1337"
          only-images
          must-delete-to-remove
          @uploading="(isUploading) => loading = isUploading"
          @warning="(msg, consoleMsg) => flashWarningUnderField(msg, consoleMsg)"
        />
      </custom-input>
      <custom-input
        stop-clearfix
        :label-as-a-container="false"
        :warning-text="warning"
        label="Logo"
      >
        <file-uploader
          v-model="value.logo"
          :submitted="false"
          :identifier="1337"
          only-images
          must-delete-to-remove
          @uploading="(isUploading) => loading = isUploading"
          @warning="(msg, consoleMsg) => flashWarningUnderField(msg, consoleMsg)"
        />
      </custom-input>
    </div>
    <ButtonGroup
      :show-prev-btn="!isOuterStep.first"
      :show-finish-btn="isOuterStep.last"
      :disabled="loading"
      @click.native="step"
    />
  </div>
</template>

<script>
import FileUploader from '@/components/Shared/FileUploader'
import CustomInput from '@/components/Shared/CustomInput'
import formHelperMixin from '@/mixins/form-helper'
import ButtonGroup from './ButtonGroup'

export default {

  name: 'StepImages',
  components: {
    FileUploader,
    CustomInput,
    ButtonGroup
  },
  mixins: [formHelperMixin],
  props: {
    // class can't be used as a prop name, so to pass any custom classes as a
    // prop, we need to pass them in as 'stepClass'
    stepClass: {
      type: String,
      default: ''
    },
    // Check if this step is the first or last and therefore decide whether to
    // show or hide the next/prev buttons
    isOuterStep: {
      type: Object,
      default: () => ({ first: true, last: false })
    },
    // The value should be passed in as a prop, and we can use the v-model
    // directive to bind to the specific part of the passed value relevant
    // for this step
    value: {
      type: Object,
      default: () => ({ files: [] })
    }

  },
  validations: {
    files: {},
    logo: {}
  },
  data () {
    return {
      submitted: false,
      loading: false,
      src: ''
    }
  },
  methods: {
    async getImage () {
      this.src = await this.$s3.get('66ceed8129e141e0b7bc7d08c9163bb1/d2z3mToMH6D22ybNoriSJq')
      console.log(this.src)
    },
    step ({ target }) {
      if (target.id === 'next-btn') {
        this.$emit('next', this.$v)
      } else if (target.id === 'prev-btn') {
        this.$emit('prev')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-section {
  padding: 20px 15px;
  // max-width: 500px;
  // background-color: $primary-base-blue-lighter;
  // background-color: var(--logo-bg-color-light);

  color:black;
  margin: 5px auto;

  &.form-instruction {
    font-size: 1.2em;
  }

  &.dark {
    // background-color: $primary-blue;
    background-color: var(--primary-color);
    color: white;
  }
}
</style>
